import React from "react";
import invariant from "tiny-invariant";
import { theme } from "@lookiero/sty-psp-ui";
import { Advice } from "./components/Advice";
import { Avoid } from "./components/Avoid";
import { BagLarge } from "./components/BagLarge";
import { BagLargeAvoid } from "./components/BagLargeAvoid";
import { Curious } from "./components/Curious";
import { DenimLarge } from "./components/DenimLarge";
import { DenimLargeAvoid } from "./components/DenimLargeAvoid";
import { DressLarge } from "./components/DressLarge";
import { DressLargeAvoid } from "./components/DressLargeAvoid";
import { Inspiration } from "./components/Inspiration";
import { JacketLarge } from "./components/JacketLarge";
import { JacketLargeAvoid } from "./components/JacketLargeAvoid";
import { OuterGarmentLarge } from "./components/OuterGarmentLarge";
import { OuterGarmentLargeAvoid } from "./components/OuterGarmentLargeAvoid";
import { Polo } from "./components/Polo";
import { PoloAvoid } from "./components/PoloAvoid";
import { ScarfLarge } from "./components/ScarfLarge";
import { ScarfLargeAvoid } from "./components/ScarfLargeAvoid";
import { ShirtLarge } from "./components/ShirtLarge";
import { ShirtLargeAvoid } from "./components/ShirtLargeAvoid";
import { ShirtRegularFit } from "./components/ShirtRegularFit";
import { ShirtSlimFit } from "./components/ShirtSlimFit";
import { ShoesLarge } from "./components/ShoesLarge";
import { ShoesLargeAvoid } from "./components/ShoesLargeAvoid";
import { ShortsLarge } from "./components/ShortsLarge";
import { ShortsLargeAvoid } from "./components/ShortsLargeAvoid";
import { SkirtLarge } from "./components/SkirtLarge";
import { SkirtLargeAvoid } from "./components/SkirtLargeAvoid";
import { Stylist } from "./components/Stylist";
import { SweaterLarge } from "./components/SweaterLarge";
import { SweaterLargeAvoid } from "./components/SweaterLargeAvoid";
import { TShirtGraphicsLarge } from "./components/TShirtGraphicsLarge";
import { TShirtGraphicsLargeAvoid } from "./components/TShirtGraphicsLargeAvoid";
import { TShirtRoundLarge } from "./components/TShirtRoundLarge";
import { TShirtRoundLargeAvoid } from "./components/TShirtRoundLargeAvoid";
import { TShirtVLarge } from "./components/TShirtVLarge";
import { TShirtVLargeAvoid } from "./components/TShirtVLargeAvoid";
import { ThumbsDownDislike } from "./components/ThumbsDownDislike";
import { Time } from "./components/Time";
import { TrouserRegularFit } from "./components/TrouserRegularFit";
import { TrouserRelaxedFit } from "./components/TrouserRelaxedFit";
import { TrouserTaperedFit } from "./components/TrouserSkinnyFit";
import { TrouserSlimFit } from "./components/TrouserSlimFit";
import { TrouserSkinnyFit } from "./components/TrouserTaperedFit";
import { TrousersLarge } from "./components/TrousersLarge";
import { TrousersLargeAvoid } from "./components/TrousersLargeAvoid";
import { Workwear } from "./components/Workwear";
const { iconSize } = theme();
const ICON = {
    ["avoid"]: Avoid,
    ["bag_large_avoid"]: BagLargeAvoid,
    ["bag_large"]: BagLarge,
    ["dress_large_avoid"]: DressLargeAvoid,
    ["dress_large"]: DressLarge,
    ["outer_garment_large_avoid"]: OuterGarmentLargeAvoid,
    ["outer_garment_large"]: OuterGarmentLarge,
    ["scarf_large_avoid"]: ScarfLargeAvoid,
    ["scarf_large"]: ScarfLarge,
    ["shirt_large_avoid"]: ShirtLargeAvoid,
    ["shirt_large"]: ShirtLarge,
    ["shoes_large_avoid"]: ShoesLargeAvoid,
    ["shoes_large"]: ShoesLarge,
    ["skirt_large_avoid"]: SkirtLargeAvoid,
    ["skirt_large"]: SkirtLarge,
    ["t_shirt_round_large_avoid"]: TShirtRoundLargeAvoid,
    ["t_shirt_round_large"]: TShirtRoundLarge,
    ["trousers_large_avoid"]: TrousersLargeAvoid,
    ["trousers_large"]: TrousersLarge,
    ["curious"]: Curious,
    ["inspiration"]: Inspiration,
    ["stylist"]: Stylist,
    ["advice"]: Advice,
    ["thumbs_down_dislike"]: ThumbsDownDislike,
    ["workwear"]: Workwear,
    ["time"]: Time,
    ["shirt_regular_fit"]: ShirtRegularFit,
    ["shirt_slim_fit"]: ShirtSlimFit,
    ["trouser_regular_fit"]: TrouserRegularFit,
    ["trouser_relaxed_fit"]: TrouserRelaxedFit,
    ["trouser_skinny_fit"]: TrouserSkinnyFit,
    ["trouser_slim_fit"]: TrouserSlimFit,
    ["trouser_tapered_fit"]: TrouserTaperedFit,
    ["t_shirt_graphics_large"]: TShirtGraphicsLarge,
    ["t_shirt_graphics_large_avoid"]: TShirtGraphicsLargeAvoid,
    ["jacket_large"]: JacketLarge,
    ["jacket_large_avoid"]: JacketLargeAvoid,
    ["polo"]: Polo,
    ["polo_avoid"]: PoloAvoid,
    ["shorts_large"]: ShortsLarge,
    ["shorts_large_avoid"]: ShortsLargeAvoid,
    ["sweater_large"]: SweaterLarge,
    ["sweater_large_avoid"]: SweaterLargeAvoid,
    ["t_shirt_v_large"]: TShirtVLarge,
    ["t_shirt_v_large_avoid"]: TShirtVLargeAvoid,
    ["denim_large"]: DenimLarge,
    ["denim_large_avoid"]: DenimLargeAvoid,
};
const Icon = ({ name, size = iconSize, style: customStyle, testID = "icon", ...props }) => {
    const IconComponent = ICON[name];
    invariant(IconComponent, "Icon does not exist");
    return React.createElement(IconComponent, { ...props, height: size, style: customStyle, testID: testID, width: size });
};
export { Icon };
